import { workspaceApi } from '@/api/workspace/index.ts';
import { selectWorkspaceToSave } from '@/api/workspace/selectors.ts';
import type { AppDispatch, AppState } from '@/store/store.ts';

export function saveWorkspace({
  getState,
  dispatch,
  mutationCacheKey,
}: {
  getState: () => AppState;
  dispatch: AppDispatch;
  mutationCacheKey?: string;
}) {
  const workspace = selectWorkspaceToSave(getState());
  return dispatch(workspaceApi.endpoints.saveWorkspace.initiate(workspace, { fixedCacheKey: mutationCacheKey }));
}
